import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Model_Volume_Component_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_MODEL_VOLUME_COMPONENT_ID:       {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Model Volume Component ID',    columnResourceName: 'colId',                     alignment: HorizAlignment.Left},  domainOptions: {} },
    VOLUME_COMPONENT_ID:                {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Volume Component ID',          columnResourceName: 'colId',                     alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    VOLUME_COMPONENT_NAME:              {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Volume Component Name',        columnResourceName: 'colComponentName',          alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    VOLUME_COMPONENT_TYPE:              {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Volume Component Type',        columnResourceName: 'colComponentType',          alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50, domainIds: 'VolumeComponentType', useIdAsKey: true}},
    WB_TREE_FOLDER_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Tree Folder'}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const ModelFunctionSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_MODEL_VOLUME_COMPONENT_ID',
                id_ui: 'VOLUME_COMPONENT_ID',
                name:  'VOLUME_COMPONENT_NAME'

    },

    searchProviderFields: vUI_Model_Volume_Component_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Model_Volume_Component',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const ModelVolumeComponentSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "ModelVolumeComponentSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id',   searchProviderFieldId: 'VOLUME_COMPONENT_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'VOLUME_COMPONENT_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'VOLUME_COMPONENT_ID', 'VOLUME_COMPONENT_NAME', 'VOLUME_COMPONENT_TYPE',
        "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelFunctionSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ModelVolumeComponentSearch: ISearch = {
    searchName: "Find Model Volume Component",
    renderOptions: {ui5ResourceId: "ModelVolumeComponentSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ModelVolumeComponentSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ModelVolumeComponentBO", "ModelVolumeComponent", ModelVolumeComponentSearch, "Model Volume Component Search")

export {ModelVolumeComponentSearch}